export const ACTIONS_ACTIVITY = {
  INVALIDATE: 'ACTIVITIES_INVALIDATE',
  RECEIVE: 'ACTIVITIES_RECEIVE',
  DELETE: 'ACTIVITY_DELETE',
  UPDATE: 'ACTIVITY_UPDATE',
};

const activityConstants = {};

export default activityConstants;
